<neo-accordion class="cm-accordion">
  <ng-content />
</neo-accordion>
